import React from 'react'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Languages from '../Components/Languages';
import WebDev from '../Components/WebDev';
import DsAlgo from '../Components/DsAlgo';
import Learning from '../Components/Learning';

export default function Skills() {
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <Box className='skillsTabs' sx={{ width: '100%', typography: 'body1' , textAlign : 'center' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" className='skillTab'>
              <Tab label="Languages" value="1" />
              <Tab label="Web Development" value="2" />
              <Tab label="DS-Algo" value="3" />
              <Tab label="Learning" value="4" />

            </TabList>
          </Box>
          <TabPanel value="1"> <Languages/>  </TabPanel>
          <TabPanel value="2"> <WebDev/> </TabPanel>
          <TabPanel value="3"> <DsAlgo/> </TabPanel>
          <TabPanel value="4"> <Learning/> </TabPanel>

        </TabContext>
      </Box>
    );
}
